module.exports = __webpack_public_path__ + "img/huace17.01713d25.jpg";